import React, { useEffect, useCallback, useMemo, useRef } from 'react';
import DesktopHeader from './Desktop/DesktopHeader';
import { isMobile } from 'react-device-detect';
import MobileHeader from './Mobile/MobileHeader';
import {
  setTabIndex,
  setTabs,
  setArrowIndex,
  setShowTabItems,
  setSelectedMobileItem,
  setIndex,
  setNavButtonsCurrent,
  setNavButtonsNew,
  setSelfCareData,
  setUserData,
  setNavItemIndex,
  toggleTabButton,
  setShowMenu,
  setAnimate,
  setHideNavigation,
} from './HeaderBlockSlice';
import { connect } from 'react-redux';

const MainHeader = (props) => {
  const {
    headerData: { tabIndex, tabs },
    setTabIndex,
    setNavButtonsCurrent,
    setNavButtonsNew,
    setSelfCareData,
    authentication,
    isBusinessNavigation,
    isBusinessNavigationMode,
    isDisplayFullAuthorizationHeader,
    setTabs,
    setUserData,
    setNavItemIndex,
    setHideNavigation,
  } = props;

  const getCurrentTabIndex = useCallback(() => {
    const headerTabs = props?.startPage?.headerNew?.expandedValue[0]?.headerTabs?.expandedValue || [];

    if (props.isBusinessNavigation?.value && headerTabs.length > 0) {
      const businessIndex = headerTabs.findIndex((tab) => tab?.isBusinessTab?.value === true);
      if (businessIndex >= 0) return businessIndex;
    }

    const urlToIndexMap = headerTabs.reduce((acc, tab, index) => {
      acc[tab.lobbyLink?.value] ??= index;

      tab.navButtonsCurrent?.expandedValue?.forEach((navButton) => {
        acc[navButton.link?.value] ??= index;
        navButton.regularButtons?.expandedValue?.forEach((regularButton) => {
          regularButton.links?.expandedValue?.forEach((link) => {
            acc[link.link?.value] ??= index;
          });
        });
      });

      tab.navButtonsNew?.expandedValue?.forEach((navButton) => {
        acc[navButton.link?.value] ??= index;
      });

      tab.selfCareData?.expandedValue?.forEach((selfCareData) => {
        acc[selfCareData.link?.value] ??= index;
      });

      return acc;
    }, {});

    const currentPath = props.currentPath;

    let currentTabIndex;

    for (const path in urlToIndexMap) {
      if (currentPath === path) {
        currentTabIndex = urlToIndexMap[path];
        return currentTabIndex;
      }
    }

    for (const path in urlToIndexMap) {
      const pathSplits = path
        .split('/')
        .filter((p) => p)
        .reverse();

      const currentPathSplits = currentPath
        .split('/')
        .filter((p) => p)
        .reverse();

      for (const pathPart of pathSplits) {
        for (const currentPart of currentPathSplits) {
          if (pathPart === currentPart) {
            currentTabIndex = urlToIndexMap[path];
            return currentTabIndex;
          }
        }
      }
    }

    return 0;
  }, [
    props?.startPage?.headerNew?.expandedValue,
    props.isBusinessNavigation?.value,
    props.currentPath
  ]);

  const getCurrentNavItemIndex = useCallback(
    (currentTabIndex) => {
      const currentTab =
        props?.startPage?.headerNew?.expandedValue[0]?.headerTabs?.expandedValue[currentTabIndex];

      const navButtons = [
        ...(currentTab?.navButtonsCurrent?.expandedValue || []),
        ...(currentTab?.navButtonsNew?.expandedValue || []),
      ];

      const urlToIndexMap = navButtons.reduce((acc, navButton, index) => {
        acc[navButton.link?.value] = index;

        navButton.regularButtons?.expandedValue?.forEach((rb) =>
          rb.links?.expandedValue?.forEach((link) => {
            acc[link.link.value] = index;
          })
        );

        return acc;
      }, {});

      return urlToIndexMap[props.currentPath];
    },
    [
      props?.startPage?.headerNew?.expandedValue,
      props.currentPath
    ]
  );

  const handleSelectNavItem = useCallback(
    (currentTabIndex) => {
      const currentNavItemIndex =
        history.state?.navItemIndex >= 0 &&
          history.state?.pathname === props.currentPath
          ? history.state.navItemIndex
          : getCurrentNavItemIndex(currentTabIndex);
      setNavItemIndex(currentNavItemIndex);
    },
    [
      getCurrentNavItemIndex,
      setNavItemIndex,
      props.currentPath
    ]
  );

  const handleSelectTab = useCallback(() => {
    let currentTabIndex =
      history.state?.tabIndex >= 0 &&
        history.state?.pathname === props.currentPath
        ? history.state.tabIndex
        : getCurrentTabIndex();

    if (currentTabIndex !== undefined && currentTabIndex !== -1) {
      setTabIndex(currentTabIndex);
    }

    handleSelectNavItem(currentTabIndex);
  }, [
    getCurrentTabIndex,
    handleSelectNavItem,
    setTabIndex,
    props.currentPath
  ]);

  const headerTabs = useMemo(
    () => props?.startPage?.headerNew?.expandedValue[0]?.headerTabs?.expandedValue,
    [props?.startPage?.headerNew?.expandedValue]
  );

  useEffect(() => {
    if ((!tabs || tabs.length === 0) && headerTabs) {
      setTabs(headerTabs);
    }
  }, [headerTabs, setTabs, tabs]);

  useEffect(() => {
    if (headerTabs && headerTabs.length > 0 && props.currentPath) {
      handleSelectTab();
    }
  }, [props.currentPath, headerTabs, handleSelectTab]);

  useEffect(() => {
    if (tabs !== [] && tabs != undefined) {
      const currentTab = tabs[tabIndex];
      if (!currentTab) return;

      setNavButtonsCurrent(currentTab?.navButtonsCurrent?.expandedValue || null);
      setNavButtonsNew(currentTab?.navButtonsNew?.expandedValue || null);
      setSelfCareData(currentTab?.selfCareData?.expandedValue?.[0] || null);
    }
  }, [tabs, tabIndex, setNavButtonsCurrent, setNavButtonsNew, setSelfCareData]);

  useEffect(() => {
    const {
      isFullAuthenticated,
      isOtpAuthenticated,
      userDetails: { contactNumber, firstName, lastName } = {},
    } = authentication?.loginData || {};

    setUserData({
      isFullAuthenticated,
      isOtpAuthenticated,
      contactNumber,
      firstName,
      lastName,
    });
  }, [
    authentication?.loginData?.isFullAuthenticated,
    authentication?.loginData?.isOtpAuthenticated,
    authentication?.loginData?.userDetails?.contactNumber,
    authentication?.loginData?.userDetails?.firstName,
    authentication?.loginData?.userDetails?.lastName,
    setUserData,
  ]);

  useEffect(() => {
    if (!isDisplayFullAuthorizationHeader) {
      setHideNavigation(false);
      return;
    }

    const { isFullAuthenticated, isOtpAuthenticated, isOtpExtendedAuthenticated } =
      authentication?.loginData || {};

    const isAuthenticated =
      isFullAuthenticated || isOtpAuthenticated || isOtpExtendedAuthenticated;

    setHideNavigation(isAuthenticated);
  }, [
    isDisplayFullAuthorizationHeader,
    authentication?.loginData?.isFullAuthenticated,
    authentication?.loginData?.isOtpAuthenticated,
    authentication?.loginData?.isOtpExtendedAuthenticated,
    setHideNavigation,
  ]);

  const Header = isMobile ? MobileHeader : DesktopHeader;

  return <Header context={props.context} isBusinessNavigation={props.isBusinessNavigation?.value} startPage={props.startPage} />;
};

const mapStateToProps = (state) => {
  return {
    headerData: state.Header,
    authentication: state.authentication,
    selfcarePage: state.selfcarePage,
    currentPath: state.ViewContext?.currentPath,
  };
};

const mapDispatchToProps = {
  setTabs,
  setTabIndex,
  setArrowIndex,
  setShowTabItems,
  setSelectedMobileItem,
  setIndex,
  setNavButtonsCurrent,
  setNavButtonsNew,
  setSelfCareData,
  setUserData,
  setNavItemIndex,
  setShowMenu,
  setAnimate,
  toggleTabButton,
  setHideNavigation,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainHeader);
